import Ajax from '../common/ajax'

export default {
  model: 'finance',
  getMerchantlistBank (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/Merchant/listBank`, queryParam)
  },
  merchantBind (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/Merchant/bind`, queryParam)
  },
  merchantCheck (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/Merchant/checkAmount`, queryParam)
  },
  getMerchantInfo (id) {
    return Ajax.get(`/api/gradeOrganization/financeProxy/v1/Merchant/info/${id}`)
  },
  merchantAdd (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/Merchant/add`, queryParam)
  },
  merchantUpdate (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/Merchant/update`, queryParam)
  },
  getSettlementDetail (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/settlement/settlementSubjectInfo`, queryParam)
  },
  getSettlementInfo (id) {
    return Ajax.get(`/api/gradeOrganization/financeProxy/v1/settlement/info/${id}`)
  },
  getSettlementSchoolList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/settlement/settlementSchoolPage`, queryParam)
  },
  settlementHandle (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/financeProxy/v1/settlement/schoolHandle`, queryParam)
  }
}
